import { Component } from '@angular/core';

@Component({
  selector: 'selectable-tabs',
  templateUrl: './option-selection-panel.html',
  styleUrls: ['./option-selection-panel.css']
})
export class OptionSelectionPanel {
  constructor() {
  }
 
}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/option-selection-panel/option-selection-panel.ts